export const THEME_STORAGE_KEY = 'factrans-ats-theme';

export function getInitialTheme() {
  return 'light';
}

export function getNextTheme() {
  return 'light';
}

export function getThemeStorageValue() {
  return 'light';
}
